import { useAtom, useAtomValue } from 'jotai';
import { House } from 'lucide-react';
import { useEffect } from 'react';

import {
  computeShowsHeidi2HomeDot,
  heidi2EvidenceTourHomeVisitedAtom,
  heidi2EvidenceTourStepAtom,
  useHeidi2ExploreLaterState,
} from '../../../data/heidi-2';

/**
 * The Home rail icon, with a dot while the Heidi II Evidence tour is still on
 * its rail spotlight (step 0), for everyone past the welcome. Reads
 * `seen_modals` directly rather than the queue, so the dot stays even when
 * pacing holds the spotlight back for the session. Reads billing, so cloud
 * builds only.
 */
export const Heidi2HomeNavIcon = ({ isOnHomeScreen }: { isOnHomeScreen: boolean }) => {
  const [hasVisitedHome, setHasVisitedHome] = useAtom(heidi2EvidenceTourHomeVisitedAtom);

  useEffect(() => {
    if (isOnHomeScreen) setHasVisitedHome(true);
  }, [isOnHomeScreen, setHasVisitedHome]);

  const showDot =
    computeShowsHeidi2HomeDot({
      ...useHeidi2ExploreLaterState(),
      step: useAtomValue(heidi2EvidenceTourStepAtom),
    }) &&
    !hasVisitedHome &&
    !isOnHomeScreen;

  return (
    // The sidebar sizes, colours and animates its icon through `[&>svg]`, so
    // the svg must stay the button's direct child: the dot is drawn inside it,
    // overflowing the top corner. The tour's first step points its arrow at
    // this svg rather than the whole item, whose label would pull it off.
    <House
      aria-hidden="true"
      className="overflow-visible"
      data-heidi-2-spotlight-target=""
    >
      {showDot ? (
        <circle
          data-testid="heidi-2-home-nav-dot"
          cx="22.5"
          cy="1.5"
          r="4"
          stroke="none"
          className="fill-accent-blue"
        />
      ) : null}
    </House>
  );
};
